<template>
  <v-layout wrap class="container px-2 py-0">
    <investor-navigation />
    <router-view />
  </v-layout>
</template>

<script>
import InvestorNavigation from '@/components/investor/InvestorNavigation.vue';

export default {
  name: 'InvestorPage',
  components: {
    InvestorNavigation,
  },
};
</script>

<style lang="scss" scoped></style>
